import { useMultiSelectActionFactory } from "./useMultiSelectActionFactory";

export default useMultiSelectActionFactory;
